import React from 'react'

import { type FooterSummaryProps } from './ChartTooltipTypes'
import styles from './_charts-tooltip.module.scss'

const FooterSummary = ({ summary }: FooterSummaryProps) => (
  <div className={styles.tooltipFooter}>{summary}</div>
)

export default FooterSummary
